import { BoxProps, Center, Spinner } from '@chakra-ui/react';

export const LoadingSpinner = ({ padding }: { padding?: BoxProps['padding'] | number }) => (
  <Center padding={padding || 4}>
    <Spinner role="progressbar" data-testid="loading-spinner" />
  </Center>
);
